<template>
  <b-form-group v-slot="{ ariaDescribedby }">
    <b-form-radio-group
      v-model="model"
      :options="options"
      :aria-describedby="ariaDescribedby"
      button-variant="outline-primary"
      name="radio-btn-outline"
      buttons
    />
  </b-form-group>

</template>

<script>
import { BFormGroup, BFormRadioGroup } from "bootstrap-vue";
import AuthHelpers from "@/utils/auth-helpers";
export default {
  components: {
    BFormGroup,
    BFormRadioGroup,
  },
  data() {
    return {
      HNGOFilterOptions: [
        { text: "الكل", value: "all" },
        { text: "معاملات الإعلام", value: "announcements" },
        { text: "بحاجة معالجة", value: "under_checking" },
        { text: "بحاجة استدراك", value: "returned_from_higher_level" },
        { text: "مًعالجة", value: "processed"},
        { text: "مُغلقة", value: "closed" },
      ],
      

      MUFilterOptions: [
        { text: "الكل", value: "all" },
        { text: "معاملات الإعلام", value: "announcements" },
        { text: "بحاجة معالجة", value: "under_checking" },
        { text: "بحاجة استدراك", value: "returned_from_higher_level" },
        { text: "مًعالجة", value: "processed"},
        { text: "مُغلقة", value: "closed" },

      ],
      model: "all",
    };
    
  },

  computed: {
    options() {
      return AuthHelpers.isUserCentral()
        ? this.MUFilterOptions 
        : this.HNGOFilterOptions  ;
    },
  },

  watch: {
    model(val) {
      this.$emit("filterChanged", val);
    },
  },
};
</script>
